
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AuthForm } from "@/components/auth/AuthForm";
import { ForgotPasswordForm } from "@/components/auth/ForgotPasswordForm";
import { useIsMobile } from "@/hooks/use-mobile";

export default function Auth() {
  const [searchParams] = useSearchParams();
  const [isSignUp, setIsSignUp] = useState(searchParams.get("signup") === "true");
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const isMobile = useIsMobile();

  // Update state when URL parameters change
  useEffect(() => {
    setIsSignUp(searchParams.get("signup") === "true");
  }, [searchParams]);

  return (
    <div className={`container mx-auto ${isMobile ? 'px-2 py-2' : 'px-4 py-8'}`}>
      <div className={`${isMobile ? 'mb-2 pt-1' : 'mb-8'}`}>
        <h1 className={`${isMobile ? 'text-2xl' : 'text-3xl'} font-bold`}>
          {isSignUp ? "Create Account" : isForgotPassword ? "Reset Password" : "Sign In"}
        </h1>
        <p className={`${isMobile ? 'text-sm mt-1' : 'mt-2'} text-muted-foreground`}>
          {isSignUp 
            ? "Join our community of film photographers"
            : isForgotPassword 
              ? "Enter your email to reset your password"
              : "Welcome back to your film photography companion"
          }
        </p>
      </div>
      
      <Card className="max-w-md mx-auto shadow-md">
        <CardHeader className={isMobile ? 'py-3 px-4' : 'px-6 py-4'}>
          <CardTitle className={`${isMobile ? 'text-lg' : 'text-xl'} mb-1`}>
            {isForgotPassword 
              ? "Reset your password" 
              : isSignUp 
                ? "Create an account" 
                : "Welcome back"
            }
          </CardTitle>
        </CardHeader>
        <CardContent className={`${isMobile ? 'py-3 px-4' : 'px-6 pb-6'} ${isSignUp ? 'pt-2' : ''}`}>
          {isForgotPassword ? (
            <ForgotPasswordForm onBack={() => setIsForgotPassword(false)} />
          ) : (
            <AuthForm 
              isSignUp={isSignUp} 
              onToggleMode={() => setIsSignUp(!isSignUp)} 
              onForgotPassword={() => setIsForgotPassword(true)} 
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
